<template>
  <div class="swiperPage">
    <el-carousel :height="SwiperPageHeight" :interval="5000" arrow="always">
      <el-carousel-item>
        <img src="../../assets/images/productCenterIMG/01.jpg" alt="" />
      </el-carousel-item>
      <el-carousel-item>
        <img src="../../assets/images/banner/rotationChart2.jpg" alt="" />
      </el-carousel-item>
      <el-carousel-item>
        <img src="../../assets/images/banner/rotationChart3.jpg" alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      imgList: [""],
      SwiperPageHeight: "600px",
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth2 = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth2(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          if (that.screenWidth >= 1200 && that.screenWidth < 1920) {
          } else if (that.screenWidth >= 980 && that.screenWidth <= 1200) {
          } else if (that.screenWidth < 980) {
          } else if (that.screenWidth >= 1920) {
          }
          // that.init()
          that.timer = false;
        }, 100);
      }
    },
  },
};
</script>
<style scoped lang="less">
.swiperPage {
  width: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel {
  .el-carousel-item {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
